export default {
    app: {
        title: '화면 크기 체커',
        subtitle: '디스플레이 화면의 너비, 높이, 인치를 측정할 수 있는 편리한 도구',
        description: '화면 크기 체커는 디스플레이 화면의 너비, 높이, 인치를 측정할 수 있는 편리한 도구입니다.',
        width: '너비',
        height: '높이',
        diagonal: '대각선',
        inches: '인치',
        pixels: '픽셀',
        screen_size: '화면 크기',
        resolution: '해상도',
        aspect_ratio: '화면비',
        pixel_density: '픽셀 밀도',
        ppi: 'PPI (인치당 픽셀 수)',
        device_info: '기기 정보',
        browser: '브라우저',
        os: '운영 체제',
        language: '언어',
        home: '홈',
        privacy_policy: '개인정보 처리방침'
    }
};
